<template>
  <div>
    <div height="100%" flat class="grey lighten-4">
      <div>
        <!-- <h1 class="pr-3"><v-icon left size="50" color="blue">mdi-cube</v-icon></h1> -->
        <slot name="headZone"></slot>
        <v-container style="max-width: 1800px" :class="classContainer">
          <slot name="containerZone"></slot>
        </v-container>
      </div>
    </div>
    <v-dialog v-model="loadingDialogStatus" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t('is_loading') }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  computed: {
    loadingDialogStatus: {
      get() {
        return !this.isSuccess;
      },
      set(value) {
        this.isSuccess = value;
      },
    },
  },
  props: {
    isSuccess: Boolean,
    isFull: Boolean,
    classContainer : String,
  },
};
</script>

<style>
</style>